@if (loaderService.displayLoader | async) {
  <div id="pause" class="d-flex align-items-center justify-content-center">
    <div id="spinner"></div>
  </div>
}
